import Axios from 'axios';

class Settings
{

    public URL = {
        host: process.env.VUE_APP_HOST,
        api: process.env.VUE_APP_HOST_API,
        static: process.env.VUE_APP_HOST_STATIC,
        data: process.env.VUE_APP_HOST_DATA,

        web_host: process.env.VUE_APP_HOST,
        web_api: process.env.VUE_APP_HOST_API,
        web_static: process.env.VUE_APP_HOST_STATIC,
        web_data: process.env.VUE_APP_HOST_DATA,

        local_host: process.env.VUE_APP_LOCAL_HOST,
        local_api: process.env.VUE_APP_LOCAL_HOST_API,
        local_static: process.env.VUE_APP_LOCAL_HOST_STATIC,
        local_data: process.env.VUE_APP_LOCAL_HOST_DATA,
    };

    public tokenCSRF: string = '';
    public mode: 'local' | 'web' = 'web';

    public async Init()
    {

        if ( window.location.href.startsWith( 'http://192.168.' )  ||
             window.location.href.startsWith( 'https://192.168.' ) ||
             window.location.href.startsWith( 'http://localhost' )   ||
             window.location.href.startsWith( 'https://localhost' ) )
        {
            console.info( 'local mode' );
            this.URL.host = this.URL.local_host;
            this.URL.api = this.URL.local_api;
            this.URL.static = this.URL.local_static;
            this.URL.data = this.URL.local_data;
            this.mode = 'local';
        } else
        {
            this.URL.host = this.URL.web_host;
            this.URL.api = this.URL.web_api;
            this.URL.static = this.URL.web_static;
            this.URL.data = this.URL.web_data;
            this.mode = 'web';
        }
    }

}

export const settings: Settings = new Settings();